import { SELECIONAR_RESERVAS_TRANSFERENCIA } from '../../actions/types'

const initialState = []

export default function reducerSelecionarReservasTransferencia (state = initialState, action) {
  switch (action.type) {
    case SELECIONAR_RESERVAS_TRANSFERENCIA: {
      return action.payload;
    }

    default: {
      return state
    }
  }
}